import { z } from "zod";
import { defineEvent } from "./registry.js";
/** Yükler keşideci adı / TCKN / IBAN TAŞIMAZ (KVKK); ayrıntı yetki denetimli API'den çekilir. */
export const instrumentBatchPostedV1 = defineEvent({
    type: "instruments.batch.posted",
    version: 1,
    description: "Çek/senet bordrosu kaydedildi (giriş, ciro, bankaya verme, tahsil, karşılıksız, keşide, ödeme…)",
    realtime: ["tenant"],
    payload: z.object({
        batchId: z.uuid(),
        companyId: z.uuid(),
        batchType: z.string(),
        batchDate: z.iso.date(),
        totalAmount: z.string(),
        lineCount: z.number().int(),
        instrumentIds: z.array(z.uuid()),
        ledgerStatus: z.enum(["POSTED", "QUEUED", "NONE"]),
    }),
});
export const instrumentBatchCancelledV1 = defineEvent({
    type: "instruments.batch.cancelled",
    version: 1,
    description: "Çek/senet bordrosu iptal edildi; fişin ters kaydı alındı, çekler önceki durumuna döndü",
    realtime: ["tenant"],
    payload: z.object({ batchId: z.uuid(), companyId: z.uuid(), instrumentIds: z.array(z.uuid()) }),
});
/** ALARM: karşılıksız dönüş (bankadan ya da ciro edilen tedarikçiden) veya senet protestosu. */
export const instrumentBouncedV1 = defineEvent({
    type: "instruments.instrument.bounced",
    version: 1,
    description: "Çek karşılıksız döndü / ciro edilen çek geri geldi / senet protesto edildi",
    realtime: ["tenant"],
    payload: z.object({
        instrumentId: z.uuid(),
        companyId: z.uuid(),
        batchId: z.uuid(),
        kind: z.enum(["CHEQUE", "PROMISSORY_NOTE"]),
        status: z.enum(["BOUNCED", "RETURNED_BOUNCED", "PROTESTED"]),
        counterpartyId: z.uuid(),
        amount: z.string(),
        dueDate: z.iso.date(),
    }),
});
/** ALARM: sabah işi — vadesi yaklaşan çek/senet (alarm modülü bildirime çevirir, Prompt 20). */
export const instrumentReminderDueV1 = defineEvent({
    type: "instruments.reminder.due",
    version: 1,
    description: "Vadesi yaklaşan çek/senet: tahsile verme hatırlatması, yarın ödenecek kendi çekimiz (bakiye yeterli mi), teminattaki çekin vadesi",
    realtime: ["tenant"],
    payload: z.object({
        companyId: z.uuid(),
        instrumentId: z.uuid(),
        kind: z.enum(["COLLECTION_DUE", "OWN_PAYMENT_DUE", "COLLATERAL_DUE"]),
        dueDate: z.iso.date(),
        daysLeft: z.number().int(),
        amount: z.string(),
        /** OWN_PAYMENT_DUE: ödeneceği hesabın bakiyesi (KMH dâhil) yetiyor mu; diğerlerinde null. */
        balanceSufficient: z.boolean().nullable(),
    }),
});
//# sourceMappingURL=instruments.v1.js.map